import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import generalActions from 'redux/actions/generalActions'
import drawItActions from 'redux/actions/drawItActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import containerSelector from 'redux/selectors/draw_it/creation_tool_timer_modal_selector'

import TimerModal from 'views/modals/timer_modal'

class DrawItTimerModalContainer extends PureComponent {

	closeModalHandler = () => {
		this.props.actions.closeModal(this.props.modalName)
	}

	render() {
		return (
			<TimerModal
				max={5999}
				min={0}
				step={15}
				value={this.props.value}
				saveHandler={this.props.actions.save}
				cancelHandler={this.props.actions.cancel}
				closeModalHandler={this.closeModalHandler}
			/>
		)
	}

}

DrawItTimerModalContainer.propTypes = {
	actions: PropTypes.object.isRequired,
	modalName: PropTypes.string,
	value: PropTypes.number,
}

DrawItTimerModalContainer.defaultProps = {
	modalName: '',
	value: null,
}

function mapStateToProps(state) {
	return containerSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: generalActions.closeModal,
		save: drawItActions.saveTimer,
		cancel: drawItActions.cancelTimer,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(DrawItTimerModalContainer)
